import { useTheme } from "@mui/material";
import { useMemo, useState } from "react";
import { usePreviewTheme } from "../../../context/StoredThemes.js";
function useTypography() {
  const { typography } = useTheme();
  const {
    api: { setTypography: setPreviewTypography },
    previewTheme: { typography: previewTypography }
  } = usePreviewTheme();
  const [expanded, setExpanded] = useState(false);
  return useMemo(() => {
    const handleOnExpand = (id, newExpanded) => {
      setExpanded(newExpanded ? id : false);
    };
    function handleTypographyChange(id, key, value) {
      const nextTypography = previewTypography ? { ...previewTypography } : {};
      if (nextTypography[id]) {
        nextTypography[id] = { ...nextTypography[id], [key]: value };
      } else {
        nextTypography[id] = { [key]: value };
      }
      setPreviewTypography(nextTypography);
    }
    function handleTypographyReset(id, key) {
      const nextTypography = previewTypography ? { ...previewTypography } : {};
      const section = nextTypography[id];
      if (section) {
        delete section[key];
        if (Object.keys(section).length === 0) {
          delete nextTypography[id];
        }
      }
      setPreviewTypography(nextTypography);
    }
    function handleTypographyResetAll(id) {
      const nextTypography = previewTypography ? { ...previewTypography } : {};
      delete nextTypography[id];
      setPreviewTypography(nextTypography);
    }
    return {
      expanded,
      onExpand: handleOnExpand,
      onTypographyChange: handleTypographyChange,
      onTypographyReset: handleTypographyReset,
      onTypographyResetAll: handleTypographyResetAll,
      previewTypography,
      typography
    };
  }, [setPreviewTypography, previewTypography, expanded, typography]);
}
export {
  useTypography
};
//# sourceMappingURL=useTypography.js.map
